import { signalrActions } from '@tabeeb/modules/signalr'

export const subscribeToProjectsUpdates = ({ subdomain }) =>
  signalrActions.invokeHubAction({ method: 'SubscribeToProjectsUpdates', args: [subdomain] })

export const unsubscribeFromProjectsUpdates = ({ subdomain }) =>
  signalrActions.invokeHubAction({ method: 'UnsubscribeFromProjectsUpdates', args: [subdomain] })
